type Params = {
    country: string;
    // useFormUtils gives `false` or `undefined` while the declaration is not loaded
    internalType?: string | false;
    formType?: string | false;
    id: string;
};

const getItemFieldTemplateViewPath = ({ country, internalType, formType, id }: Params): string | undefined => {
    if (!country || !internalType || !formType || !id) return undefined;

    return `/customs-declarations/${country}/${internalType}/item-field-templates/${formType}/${id}`;
};

export default getItemFieldTemplateViewPath;
